import { type SVGProps, forwardRef } from "react";

/**
 * PermitTypeIcon - Icon representing permit type.
 * Use for: Permit type lists, templates, configuration views.
 */
export const PermitTypeIcon = forwardRef<
	SVGSVGElement,
	Omit<SVGProps<SVGSVGElement>, "ref"> & {
		title?: string | undefined;
		titleId?: string | undefined;
	}
>(({ strokeWidth = 1.90476, ...props }, ref) => {
	return (
		<svg
			width="16"
			height="16"
			viewBox="0 0 16 16"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			ref={ref}
			aria-hidden={!props.title}
			{...props}
		>
			<title>{props.title || "Permit Type"}</title>
			<path
				strokeWidth={strokeWidth}
				d="M6.6897 10.0837C7.01185 10.0837 7.27271 10.3445 7.27271 10.6667C7.27271 10.9888 7.01185 11.2497 6.6897 11.2497H4.99829C4.67612 11.2497 4.41528 10.9889 4.41528 10.6667C4.41528 10.3445 4.67612 10.0837 4.99829 10.0837H6.6897Z"
				fill="currentColor"
			/>
			<path
				strokeWidth={strokeWidth}
				d="M9.33325 4.75031C9.65542 4.75031 9.91626 5.01115 9.91626 5.33331C9.91626 5.65548 9.65542 5.91632 9.33325 5.91632H5.00122C4.67905 5.91632 4.41821 5.65548 4.41821 5.33331C4.41821 5.01115 4.67905 4.75031 5.00122 4.75031H9.33325Z"
				fill="currentColor"
			/>
			<path
				strokeWidth={strokeWidth}
				d="M8 7.41699C8.32217 7.41699 8.58301 7.67783 8.58301 8C8.58301 8.32217 8.32217 8.58301 8 8.58301H5C4.67783 8.58301 4.41699 8.32217 4.41699 8C4.41699 7.67783 4.67783 7.41699 5 7.41699H8Z"
				fill="currentColor"
			/>
			<path
				strokeWidth={strokeWidth}
				d="M12.7498 6.677V2.00024C12.7498 1.97814 12.741 1.9563 12.7253 1.94067C12.7098 1.92528 12.6887 1.91626 12.6667 1.91626H12.6638C12.6098 1.91596 12.5562 1.93144 12.5105 1.96021L11.8933 2.35767L11.8923 2.35864C11.6592 2.5076 11.3877 2.58618 11.1111 2.58618C10.8346 2.58612 10.5638 2.50745 10.3308 2.35864L10.3298 2.35767L9.70776 1.95728C9.66234 1.92841 9.60925 1.91333 9.55542 1.91333C9.50141 1.91333 9.4486 1.9292 9.40308 1.95825L9.4021 1.95728L8.78198 2.35767L8.78101 2.35864C8.54787 2.5076 8.27642 2.58618 7.99976 2.58618C7.72329 2.58612 7.45248 2.50745 7.21948 2.35864L7.21753 2.35767L6.59741 1.95825L6.52417 1.92505C6.4986 1.91758 6.47198 1.91336 6.44507 1.91333C6.391 1.91333 6.33731 1.92914 6.29175 1.95825L5.67065 2.35767L5.66968 2.35864C5.43654 2.5076 5.16509 2.58618 4.88843 2.58618C4.61197 2.58612 4.34115 2.50745 4.10815 2.35864L4.1062 2.35767L3.48901 1.96021C3.4434 1.93151 3.39056 1.91597 3.33667 1.91626H3.33374C3.31166 1.91626 3.28979 1.92508 3.27417 1.94067C3.25854 1.9563 3.24976 1.97814 3.24976 2.00024V14.0002C3.24981 14.0222 3.25873 14.0433 3.27417 14.0588C3.2898 14.0745 3.31164 14.0833 3.33374 14.0833H3.33667C3.39062 14.0835 3.44336 14.0681 3.48901 14.0393L4.1062 13.6428L4.10815 13.6418C4.34119 13.493 4.61189 13.4134 4.88843 13.4133C5.09593 13.4133 5.30053 13.4581 5.48804 13.5432L5.66968 13.6418L5.67065 13.6428L6.2937 14.0422H6.29272C6.33816 14.0711 6.39123 14.0862 6.44507 14.0862C6.49897 14.0861 6.55197 14.0712 6.59741 14.0422C6.86884 13.8688 7.22957 13.9476 7.40308 14.219C7.57655 14.4905 7.49682 14.8512 7.22534 15.0247C6.99228 15.1736 6.72165 15.2531 6.44507 15.2532C6.16837 15.2532 5.89697 15.1736 5.66382 15.0247L5.66284 15.0237L5.04175 14.6252L4.96851 14.592C4.94271 14.5845 4.91559 14.5803 4.88843 14.5803C4.83447 14.5804 4.78155 14.5962 4.73608 14.6252L4.11597 15.0237L4.11108 15.0266C3.87838 15.1732 3.60871 15.2501 3.33374 15.2493V15.2502L3.33081 15.2493L3.32983 15.2502V15.2493C2.99973 15.2483 2.6835 15.1174 2.44995 14.884C2.21558 14.6497 2.0838 14.3317 2.08374 14.0002V2.00024C2.08374 1.66872 2.21553 1.35088 2.44995 1.11646C2.68352 0.882913 2.99963 0.752166 3.32983 0.751221V0.750244L3.33081 0.751221L3.33374 0.750244V0.751221C3.53978 0.750589 3.74271 0.792817 3.92944 0.876221L4.11108 0.9729L4.11597 0.97583L4.73608 1.37524L4.80933 1.40845C4.83489 1.41591 4.86153 1.42014 4.88843 1.42017C4.94249 1.42017 4.99619 1.40436 5.04175 1.37524L5.66284 0.97583L5.66382 0.974854C5.89697 0.825872 6.16838 0.747314 6.44507 0.747314C6.65231 0.74736 6.8564 0.791281 7.0437 0.876221L7.22534 0.974854L7.22729 0.97583L7.84741 1.37524L7.92065 1.40845C7.94622 1.41591 7.97286 1.42014 7.99976 1.42017C8.05382 1.42017 8.10752 1.40436 8.15308 1.37524L8.77319 0.97583L8.77417 0.974854C9.00733 0.825864 9.27873 0.747314 9.55542 0.747314C9.76297 0.747315 9.96748 0.791075 10.155 0.876221L10.3367 0.974854L10.3376 0.97583L10.9578 1.37524H10.9587C11.0042 1.4043 11.0571 1.4201 11.1111 1.42017C11.1652 1.42017 11.2188 1.40436 11.2644 1.37524L11.8845 0.97583L11.8894 0.9729C12.1221 0.82637 12.3918 0.750316 12.6667 0.751221V0.750244L12.6677 0.751221L12.6697 0.750244L12.6687 0.751221C12.9995 0.751737 13.3166 0.882495 13.5505 1.11646C13.7849 1.35087 13.9167 1.66878 13.9167 2.00024V6.677C13.9167 6.99906 13.6558 7.25983 13.3337 7.26001C13.0116 7.26001 12.7498 6.99917 12.7498 6.677Z"
				fill="currentColor"
			/>
			<path
				strokeWidth={strokeWidth}
				fillRule="evenodd"
				clipRule="evenodd"
				d="M11.9978 10.5001C11.1694 10.5001 10.4978 11.1717 10.4978 12.0001C10.4978 12.8285 11.1694 13.5001 11.9978 13.5001C12.8262 13.5001 13.4978 12.8285 13.4978 12.0001C13.4978 11.1717 12.8262 10.5001 11.9978 10.5001ZM8.59375 12.0001C8.59375 10.1201 10.1178 8.59601 11.9978 8.59601C13.8778 8.59601 15.4019 10.1201 15.4019 12.0001C15.4019 13.8801 13.8778 15.4042 11.9978 15.4042C10.1178 15.4042 8.59375 13.8801 8.59375 12.0001Z"
				fill="currentColor"
			/>
			<path
				strokeWidth={strokeWidth}
				fillRule="evenodd"
				clipRule="evenodd"
				d="M13.5752 12.667C13.7238 12.2211 14.2057 11.9801 14.6516 12.1287L15.4175 12.384C15.8634 12.5327 16.1044 13.0146 15.9558 13.4605C15.8071 13.9064 15.3252 14.1474 14.8793 13.9987L14.1134 13.7434C13.6675 13.5948 13.4265 13.1129 13.5752 12.667Z"
				fill="currentColor"
			/>
			<path
				strokeWidth={strokeWidth}
				fillRule="evenodd"
				clipRule="evenodd"
				d="M8.0439 10.5397C8.19253 10.0938 8.67448 9.85285 9.12036 10.0015L9.88627 10.2568C10.3322 10.4054 10.5731 10.8874 10.4245 11.3333C10.2759 11.7791 9.79393 12.0201 9.34805 11.8715L8.58213 11.6162C8.13625 11.4676 7.89527 10.9856 8.0439 10.5397Z"
				fill="currentColor"
			/>
			<path
				strokeWidth={strokeWidth}
				fillRule="evenodd"
				clipRule="evenodd"
				d="M11.3327 13.5752C11.7786 13.7238 12.0196 14.2058 11.8709 14.6517L11.6156 15.4176C11.467 15.8635 10.985 16.1045 10.5392 15.9558C10.0933 15.8072 9.85231 15.3253 10.0009 14.8794L10.2562 14.1134C10.4049 13.6676 10.8868 13.4266 11.3327 13.5752Z"
				fill="currentColor"
			/>
			<path
				strokeWidth={strokeWidth}
				fillRule="evenodd"
				clipRule="evenodd"
				d="M12.7032 13.5076C13.1395 13.333 13.6348 13.5453 13.8094 13.9817L14.1498 14.8327C14.3243 15.2691 14.1121 15.7643 13.6757 15.9389C13.2393 16.1135 12.744 15.9012 12.5695 15.4648L12.2291 14.6138C12.0545 14.1774 12.2668 13.6821 12.7032 13.5076Z"
				fill="currentColor"
			/>
			<path
				strokeWidth={strokeWidth}
				fillRule="evenodd"
				clipRule="evenodd"
				d="M10.3203 8.06109C10.7567 7.88654 11.252 8.0988 11.4265 8.53519L11.767 9.38621C11.9415 9.8226 11.7292 10.3179 11.2929 10.4924C10.8565 10.667 10.3612 10.4547 10.1867 10.0183L9.84625 9.16731C9.6717 8.73092 9.88395 8.23565 10.3203 8.06109Z"
				fill="currentColor"
			/>
			<path
				strokeWidth={strokeWidth}
				fillRule="evenodd"
				clipRule="evenodd"
				d="M10.4924 12.7049C10.667 13.1413 10.4547 13.6365 10.0183 13.8111L9.1673 14.1515C8.73091 14.326 8.23565 14.1138 8.06109 13.6774C7.88654 13.241 8.0988 12.7457 8.53518 12.5712L9.3862 12.2308C9.82258 12.0562 10.3178 12.2685 10.4924 12.7049Z"
				fill="currentColor"
			/>
			<path
				strokeWidth={strokeWidth}
				fillRule="evenodd"
				clipRule="evenodd"
				d="M15.9377 10.3232C16.1123 10.7595 15.9 11.2548 15.4636 11.4294L14.6126 11.7698C14.1762 11.9443 13.681 11.7321 13.5064 11.2957C13.3319 10.8593 13.5441 10.364 13.9805 10.1895L14.8315 9.84906C15.2679 9.6745 15.7632 9.88676 15.9377 10.3232Z"
				fill="currentColor"
			/>
			<path
				strokeWidth={strokeWidth}
				fillRule="evenodd"
				clipRule="evenodd"
				d="M13.4616 8.0439C13.9075 8.19253 14.1485 8.67448 13.9998 9.12037L13.7445 9.88629C13.5959 10.3322 13.114 10.5732 12.6681 10.4245C12.2222 10.2759 11.9812 9.79394 12.1298 9.34806L12.3851 8.58214C12.5338 8.13625 13.0157 7.89527 13.4616 8.0439Z"
				fill="currentColor"
			/>
		</svg>
	);
});
